
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1a1 1 0 00-2 0h2zM7.293 17.707a1 1 0 001.414 0l6.364-6.364a1 1 0 00-1.414-1.414L8 15.586 2.343 9.929A1 1 0 00.93 11.343l6.364 6.364zM7 1v16h2V1H7z","fill":"currentColor"}})])
          )
        }
      }
    